module.exports = __webpack_public_path__ + "img/health24_7-9-2021.08b80538.jpg";